import { render } from "./EntityBanner.vue?vue&type=template&id=49cdaa60&ts=true"
import script from "./EntityBanner.vue?vue&type=script&lang=ts"
export * from "./EntityBanner.vue?vue&type=script&lang=ts"

import "./EntityBanner.vue?vue&type=style&index=0&id=49cdaa60&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__